import { useEffect, useRef, useState } from 'react';

import Text from '@zenbusiness/zui/Text';
import Tooltip from '@zenbusiness/zui/Tooltip';

function OverflowText({ children }) {
  const [isOverflowed, setIsOverflow] = useState(false);
  const textElementRef = useRef();

  useEffect(() => {
    const textElement = textElementRef.current;

    if (textElement) {
      setIsOverflow(textElement.scrollWidth > textElement.clientWidth);
    }
  }, []);

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: '1rem',
            fontSize: '0.875rem',
            padding: '1rem',
          },
        },
      }}
      disableHoverListener={!isOverflowed}
      disableTouchListener={!isOverflowed}
      enterTouchDelay={0}
      leaveTouchDelay={15000}
      title={children}
    >
      <Text
        ref={textElementRef}
        aria-describedby={isOverflowed ? 'tooltip' : undefined}
        size="md"
        sx={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        {children}
      </Text>
    </Tooltip>
  );
}

export default OverflowText;
